import { gql } from '@apollo/client';
import {
  COMPLETED_TASK_FRAGMENT,
  TASK_FORM_ITEM_FRAGMENT,
} from '../../../../../../../common/form/task-form/model/task-items.gql';

export const GET_TASK_FOR_INCOMING_VOLUNTEER = gql`
  query GetTaskForIncomingVolunteer(
    $completedTaskId: String!
    $taskId: String!
    $profileId: String!
    $userId: String!
  ) {
    vm {
      programs {
        programId
        name
        dateSuspended
      }
      profile(profileId: $profileId, userId: $userId) {
        profileId
        firstName
        lastName
        preferredName
        dateOfBirth
        contactNumber
        email
        aboutMe
        programs {
          programId
          name
        }
        completedTasks {
          ...CompletedTask
        }
      }
      application(userId: $userId) {
        relevantTasks {
          taskId
          cake {
            cakeType
          }
        }
      }
      completedTask(completedTaskId: $completedTaskId) {
        ...CompletedTask
        events {
          completedTaskEventId
          message
          startDateTime
          endDateTime
          status
          placesAddress {
            description
            formatted
            placesId
            latLong {
              lat
              long
            }
          }
          remoteLocation
          managers {
            managerId
            profile {
              profileId
              firstName
              lastName
            }
          }
          participantFeedback
          rescheduleCount
          originalScheduledDate
          dateCreated
          bookableTimeSlotId
        }
      }
      task(taskId: $taskId) {
        order
        dateRemoved
        allowUpdate
        taskId
        title
        description
        isRefereeCheckTask
        isEventTask
        isBookable
        managerCompleted
        cake {
          title
        }
        taskItems {
          ...TaskFormItem
        }
        bookableTimeSlots {
          bookableTimeSlotId
          startDateTime
          endDateTime
          timezone
          placesAddress {
            description
            formatted
            placesId
            latLong {
              lat
              long
            }
          }
          remoteLocation
          maxCapacity
          currentBookings
          availableSpots
          isAvailable
          message
          managers {
            managerId
            profile {
              firstName
              lastName
            }
          }
          dateCreated
        }
        eventConfig {
          locationInstructions
          schedulingInstructions
          allowSelfBooking
        }
      }
      refereeCheck(profileId: $profileId, taskId: $taskId) {
        completedTaskRefereeContactId
        refereeOrder
        refereeName
        refereeEmail
        refereePhone
        submissionToken
        dateContactProvided
        dateInvited
        dateLastReminded
        dateSubmitted
        isCompleted
        submissionData
      }
    }
  }

  ${COMPLETED_TASK_FRAGMENT}
  ${TASK_FORM_ITEM_FRAGMENT}
`;
